import { Component, HostListener, OnInit } from '@angular/core';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { PagesService } from 'src/app/_services/pages.service';
import { StorageService } from 'src/app/_services/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/_models/user.model';
import { AuthService } from 'src/app/_services/auth.service';
import { Page } from 'src/app/_models/page.model';
import { Routes } from 'src/app/_config/routes.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'DCO-header',
  templateUrl: './header.component.html',
  standalone: false,
})
export class HeaderComponent implements OnInit {
  private userSuscription$!: Subscription;
  private languagesDownloaded$!: Subscription;
  private languageChanged$!: Subscription;
  private pagesDownload$!: Subscription;
  menuAbierto = false;
  allowHelp = environment.allowHelp;
  public pages: Page[] = [];
  username: string;
  public languages = [];
  public selectedLanguage = '';
  pagesLoaded = false;
  constructor(
    private _pagesService: PagesService,
    private authService: AuthService,
    private _translationService: LanguageManagerService,
    private storageService: StorageService,
    public router: Router,
    private route: ActivatedRoute,
  ) {}

@HostListener('document:click')
  clickOut() {
    this.menuAbierto = false;
  }

  ngOnInit(): void {
    this.languages = this._translationService.languages;
    this.username = this.storageService.getUsername();
    //this.pages = this._pagesService.defaultPages;
    this.userSuscription$ = this.storageService.userInfo.subscribe((user) => {
      // si se moficia el usuario (login o logout)
      // recibimos el evento, actualizamos el nombre que se ve (o ponemos login)
      this.updateUserData(user);
      // actualizamos las paginas visibles para el usuario
      this._pagesService.Pages_Get();
    });
    this.languagesDownloaded$ =
      this._translationService.languagesDownloaded$.subscribe((languages) => {
        // cuando termina de cargar los idiomas mostramos el desplegable
        this.languages = languages;
      });
    this.languageChanged$ = this._translationService.languageChanged$.subscribe(
      (selectedLanguage) => {
        // cuando recibimos el evento de cambiar de idioma cambiamos la seleccion del desplegable
        // eso ocurre al cargar la pagina, el desplegable puede poner el primer valor
        // pero podemos tener guardado un idioma determinado seleccionado
        this.selectedLanguage = selectedLanguage;
      },
    );
    this.pagesDownload$ = this._pagesService.pagesDownload$.subscribe(
      (pages) => {
        // cuando se terminan de cargar las paginas posibles
        // se contatenan las paginas por defecto (home) con las que nos devuelve la api
        this.pages = pages;
        this.pagesLoaded = true;
      },
    );
    // al cargar el header se llama a la api de paginas por primera vez
    //this._pagesService.Pages_Get();
  }

  updateUserData(user: User) {
    if (user) {
      this.username = user.user;
    } else {
      this.username = null;
    }
  }

  logOut() {
    this.authService.logOut();
    if (environment.logOutUrl != '') {
      this.router.navigate([Routes.LOGOUT]);
    } else {
      this.router.navigate([Routes.LOGIN]);
    }
  }

  component(component: string) {
    this.storageService.setComponent(component);
  }
  SetLanguage(lang: any) {
    this._translationService.SetLanguage(lang);
  }
}
